// Force the css import to be a separate file
// import {default as CSSLoader} from 'css';
// CSSLoader.separateCSS = true;
// CSSLoader.buildCSS    = false;
// import '@nuskin/configuration-sdk';
// import '@nuskin/events';
import '@nuskin/ns-util';
import '@nuskin/ns-account';
import '@nuskin/ns-common-angularjs';
import '@nuskin/ns-shop';
import './cartModule.js';
import './app.js';
import './directives/productSearchModule.js';
import './directives/scanCardDirective.js';
import './controllers/cartCtrl.js';
import './controllers/versionCtrl.js';

import './stylesheets/cart.scss';

import Vue from 'vue';
import Vuetify from 'vuetify';
import vueCustomElement from 'vue-custom-element';
Vue.use(Vuetify);
Vue.use(vueCustomElement);

import {NsHeader, NsFooter, NsSearchbar} from '@nuskin/app-components';
import {NsIcon} from '@nuskin/ns-icon';
import {NuHomeCloneProductCarousel, NsProductRecsCarousel} from '@nuskin/product-components';
import ExclusiveOfferToast from './components/ExclusiveOfferToast.vue';
Vue.customElement('ns-header', NsHeader);
Vue.customElement('ns-footer', NsFooter);
Vue.customElement('exclusive-offer-toast', ExclusiveOfferToast);
Vue.customElement('ns-icon', NsIcon);
Vue.customElement('ns-searchbar', NsSearchbar);
Vue.customElement('nu-home-clone-product-carousel', NuHomeCloneProductCarousel);
Vue.customElement('ns-product-recs-carousel', NsProductRecsCarousel);

export {default as configSdk} from '@nuskin/configuration-sdk';
export {RunConfigService, ShoppingContext, init, events} from '@nuskin/ns-util';
export {eidLogin, Receiver} from '@nuskin/ns-shop';
